import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDataset } from "../../Api/newSockets.api";
import { ReactComponent as LoadingIcon } from "../../assets/icons/loading.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/file_upload.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

type Props = {
  datasetId?: any;
  uploadImages: any;
  uploadedImages: any;
  removeImage: any;
};

const UploadImage = (props: Props) => {
  const datasetId = props.datasetId;
  //   console.log("This is datasetId" + datasetId);
  const { getDataset, uploadImage, connected } = useDataset();
  const [dataset, setDataset] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [currentAttachments, setCurrentAttachments] = useState<any>([]);
  console.log("Current Attachments", currentAttachments);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setLoading(true);
      const mergedFiles = [...currentAttachments, ...acceptedFiles];
      setCurrentAttachments(mergedFiles);
      console.log("Merge files", mergedFiles);
      props.uploadImages(
        mergedFiles.map((file) =>
          Object.assign(
            file,
            { meta: { datasetId: datasetId } },
            { preview: URL.createObjectURL(file) }
          )
        )
      );
      setLoading(false);

      // setTimeout(() => {
      //   setLoading(false);
      // }, 5000);
    },
  });

  useEffect(() => {
    getDataset(datasetId).then((data: any) => {
      setDataset(data);
    });
  }, [connected]);

  const removeImage = (image) => {
    debugger;
    const filteredImages = currentAttachments.filter(
      (attachment) => attachment !== image
    );
    setCurrentAttachments(filteredImages);
    props.uploadImages(filteredImages);
  };

  // useEffect(() => {
  //   uploadImage(uploadedImages);
  //   dohvatit ponovo dataset
  // });

  // useEffect(() => {
  //   uploader.submitFiles(uploadedImages);
  // }, [uploadedImages]);

  console.log("Uploaded Images", props.uploadedImages);

  return (
    <div>
      <div {...getRootProps({ className: "dropArea" })}>
        <input {...getInputProps()} />
        <div className="dropArea-content">
          {<UploadIcon className="upload-icon" />}
          <p>Select a file or drag here</p>
          <button className="select-button">Select a file</button>
        </div>
      </div>
      {props.uploadedImages && props.uploadedImages.length > 0 && (
        <div className="thumbsContainer">
          {currentAttachments.map((image) => (
            <div className={`thumb ${loading && "brightnes-reducer"}`}>
              <div
                className="close-container"
                onClick={() => removeImage(image)}
              >
                <CloseIcon width={16} height={16} fill={"white"} />
              </div>
              <img alt="" src={image.preview} className="img" />
              {loading && <LoadingIcon className="spinner" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UploadImage;
